import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class PostDeliveryActivities extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'postDeliveryActivities'}
            title={'PROCEDURE P12.0 POST DELIVERY ACTIVITIES'}
            exportTitle={'<h2>Procedure P12.0 Post Delivery Activities</h2>'}
            exportFileName={'post_delivery_activities.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (PostDeliveryActivities);
